import Fragment from "./fragment";
import FragmentDataType from "../enums/fragment-data-type";
import FragmentSummary from "./fragment-summary";
import { teamReducer } from "../../../storage/reducers";
import {
    getPenaltyTeamIds,
    isPenaltyRestoringPossession
} from "../utils/context-utils";
import Ruleset from "../enums/ruleset";
import PenaltyType from "../enums/penalty-type";

const FLAG_FOOTBALL_ONLY_CODES = new Set([
    "FG",
    "SC",
    "DV",
    "JMP",
    "IRX",
    "TCK"
]);

export default class Penalty extends Fragment {
    constructor(penaltyType, team) {
        super();
        this.penaltyType = penaltyType;
        this.team = team;

        this.requiredData = [
            {
                name: "penaltyType",
                type: FragmentDataType.PenaltyType,
                displayName: "Penalty type",
                title: "Penalty type",
                subtitle: "Select the penalty type",
                getPenaltyTypes: () => {
                    const allPenalties = Object.values(PenaltyType);
                    if (this.ruleSetId === Ruleset.DefaultFlagFootball.code) {
                        return allPenalties;
                    }
                    return allPenalties.filter(
                        (p) => !FLAG_FOOTBALL_ONLY_CODES.has(p.code)
                    );
                }
            },
            {
                name: "team",
                type: FragmentDataType.Team,
                displayName: "Team",
                title: "Team",
                subtitle: "Select the team"
            }
        ];
    }

    getFragmentTeamId() {
        return this.team?.id;
    }

    updateSummaryContext(summaryContext, play) {
        const { offenseTeamId } = getPenaltyTeamIds(play);
        const isPossessionRestored = isPenaltyRestoringPossession(
            play,
            this,
            summaryContext
        );

        summaryContext.homeTeamHasPossession = isPossessionRestored
            ? offenseTeamId === summaryContext.homeTeamId
            : summaryContext.homeTeamHasPossession;
    }

    summarize(summaryContext) {
        const { name } = this.penaltyType || {};
        const { teamName } = this.team || {};

        let message = "";
        if (name && teamName) {
            message = `${name} ${teamName} Penalty`;
        }

        return new FragmentSummary(message);
    }

    toJSON() {
        return {
            ...super.toJSON(),
            team: teamReducer(this.team, "teamName")
        };
    }
}
